import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
    namespaced: true,
    state: {
        goodsExportUrls: [],
        isFetchedGoodsExportUrls: false
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
        updateOneExportUrl(state, data){
            let array = state.goodsExportUrls;
            let itIsNewExportName = true;
            array = array.map((item)=>{
                if(item.export_name===data.export_name) {
                    item = data.data;
                    itIsNewExportName = false;
                }
                return item;
            })
            if(itIsNewExportName){
                array.push(data.data)
            }
            updateField(state, {path:'goodsExportUrls', value:array});
            state = {...state}
        },
    },
    actions: {
        updateGoodsExportUrls({ commit, state, dispatch }, payload){
            updateField(state, {
                path: "isFetchedGoodsExportUrls",
                value: false,
            });
            return axios.put(this._vm.$apiURL +"/goods_export_urls/"+payload.export_name, {payload})
                .then((response) => {
                    commit('updateOneExportUrl', {
                        export_name: payload.export_name,
                        data: response.data.data,
                    });
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, {
                        path: "isFetchedGoodsExportUrls",
                        value: true,
                    });
                });
        },
        getGoodsExportUrls({ commit, state, dispatch }){
            updateField(state, {
                path: "isFetchedGoodsExportUrls",
                value: false,
            });
            return axios.get(this._vm.$apiURL +"/goods_export_urls")
                .then((response) => {
                    updateField(state, {
                        path: "goodsExportUrls",
                        value: response.data.data,
                    });
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, {
                        path: "isFetchedGoodsExportUrls",
                        value: true,
                    });
                });
        }
    },
};
